/*  ========================================================================
    # Component - Expandable Image
    ========================================================================  */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LazyImage from '../../components/LazyImage';
import LazySource from '../../components/LazySource';
import { breakpoints } from '../../helpers/breakpoints';
import Lightbox from '../../components/Lightbox';

const ExpandableImage = ({ image, classes }) => {
  const [showModal, setShowModal] = useState(false);

  const showModalHandler = () => {
    setShowModal(!showModal);
  };

  const clickedImageHandler = () => {
    showModalHandler();
  };

  return (
    <>
      <LazyImage
        alt={image.alt}
        defaultUrl={image.sizes.medium_large}
        placeholderUrl={image.sizes.placeholder}
        figureClass={`c-expandable-image ` + classes}
        onClick={() => clickedImageHandler()}
        hasEnlarge={true}
      >
        <LazySource srcSet={image.sizes.large} mediaMin={breakpoints.xl} />
        <LazySource srcSet={image.sizes.medium_large} mediaMin={breakpoints.lg} />
      </LazyImage>
      <Lightbox onClose={showModalHandler} show={showModal}>
        <LazyImage
          alt={image.alt}
          defaultUrl={image.sizes.medium_large}
          placeholderUrl={image.sizes.placeholder}
          figureClass='s-prices-and-plan__lightbox-image'
        >
          <LazySource srcSet={image.sizes.large} mediaMin={breakpoints.md} />
        </LazyImage>
      </Lightbox>
    </>
  );
};

ExpandableImage.propTypes = {
  image: PropTypes.object,
  classes: PropTypes.string
};

export default ExpandableImage;
